import { useEffect, useState } from "react";

/** `value` once it has held still for `delayMs` (the estimate's 300 ms,
 *  docs/08 §2). Callers memoize object values so an equal re-creation does
 *  not restart the wait. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
